"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailQuestionTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const functions_1 = require("../functions");
const AnswerContainer_1 = require("./AnswerContainer");
const DetailQuestionStyled = styled_components_1.default.div `
	.fext-field {
		flex: 1;
	}

	.choice-subject-wrap {
		flex-direction: column !important;
		gap: 36px !important;
		justify-content: center !important;
		align-items: center !important;

		.label {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			letter-spacing: var(--b3-letter-spacing, -0.02em);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			align-self: stretch;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			min-height: 25px;
		}

		.question-group {
			border-radius: 8px;
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 1px;
			padding: 24px 60px 24px 60px;
			display: flex;
			flex-direction: column;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}

		.checkbox {
			flex-direction: column;
		}
	}

	.button-container {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding: 0 16px 0 0;
	}

	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 12px;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	flex-shrink: 0;
	position: relative;
	height: 100%;

	/* .fext-field {
		height: 100%;
		overflow: hidden;
	} */

	.task-label {
		width: 100%;
	}

	.no-question-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;

		.fext-field {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b1-font-size, 20px);
				line-height: var(--b1-line-height, 42px);
				font-weight: var(--b1-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}

	.task-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: column;
			gap: 6px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			.input_answer_wrapper {
				background: #ffffff;
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px;
				padding: 4px 10px 4px 10px;
				display: flex;
				flex-direction: row;
				gap: 6px;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				position: relative;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}

			.body-item {
				width: 100%;
			}

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 12px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}
	}
	.input_point_wrapper {
		background: #ffffff;
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 10px;
		display: flex;
		flex-direction: row;
		gap: 6px;
		align-items: center;
		justify-content: center;
		position: relative;
		max-width: 80px;
		height: 38px;

		input {
			width: 100%;
			outline: none !important;
			border: none !important;
			padding: 0 !important;
			background: transparent;
		}
	}

	.detail_txt {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}

	.subject-item-wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.subject-item-title {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 600;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	.omr-point-wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
	}

	.submission-header {
		gap: 24px;
		width: 100%;
		display: flex;
		flex-direction: column;
		padding-bottom: 20px;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	gap: 21px;
	align-items: flex-end;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	${props => props.$isTablet &&
    `flex: 1;
	
		.scroll-content {
			gap: 0px!important;
		}
	`}

	/* .fext-field {
		height: 100%;
		overflow: hidden;
	} */

	.task-label {
		width: 100%;
	}

	.no-question-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;

		.fext-field {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b1-font-size, 20px);
				line-height: var(--b1-line-height, 42px);
				font-weight: var(--b1-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}

	.task-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 8px 16px 8px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.input_answer_wrapper {
				background: #ffffff;
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px;
				padding: 4px 10px 4px 10px;
				display: flex;
				flex-direction: row;
				gap: 6px;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				position: relative;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}
	}
	.input_point_wrapper {
		background: #ffffff;
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 4px 10px 4px 10px;
		display: flex;
		flex-direction: row;
		gap: 6px;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;

		input {
			width: 100%;
			outline: none !important;
			border: none !important;
			padding: 0 !important;
			background: transparent;
		}
	}

	.detail_txt {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		// line-height: 32px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}
`;
const count = 100;
exports.DetailQuestionTable = react_1.default.memo(({ item, isTest, isSubmit, isOpen, test_id, subject_name, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [allSubject, setAllSubject] = (0, react_1.useState)([]);
    const [subjectList, setSubjectList] = (0, react_1.useState)([]);
    const [selectSubject, setSelectSubject] = (0, react_1.useState)();
    const [omrType, setOmrType] = (0, react_1.useState)('');
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        const headTitleList = [
            { title: 'subject_item', space: 2, sort: false },
            { title: 'no', space: 1, sort: false },
            ...(isSubmit
                ? [
                    { title: 'answer', space: 1, sort: false },
                    { title: 'submitAnswer', space: 1, sort: false },
                    { title: 'errata', space: 1, sort: false },
                ]
                : [{ title: 'answer', space: 4, sort: false }]),
            { title: 'score', space: 1, sort: false },
            ...(isSubmit ? [{ title: 'errorRates', space: 1, sort: false }] : []),
        ];
        const tableReadDataKeys = [
            { title: 'subject_item', space: 2 },
            { title: 'number', space: 1 },
            ...(isSubmit
                ? [
                    { title: 'answer', space: 1 },
                    { title: 'submitAnswer', space: 1 },
                    { title: 'errata', space: 1 },
                ]
                : [{ title: 'omr', space: 4 }]),
            { title: 'point', space: 1 },
            ...(isSubmit ? [{ title: 'errorRates', space: 1 }] : []),
        ];
        return { headTitleList, tableReadDataKeys };
    }, [isSubmit]);
    const submitAnswerMutation = (0, react_query_1.useMutation)(server_1.postSubmitAnswer);
    // 제출 진행 중 재진입 방지(더블클릭/이중 탭 이중 발사 차단) — 동기 ref 가드
    const isSubmittingRef = react_1.default.useRef(false);
    const { data, refetch } = (0, server_1.useQuestionList)({
        test_id,
        // offset: page === 0 ? 0 : page * 100,
        // limit: 100,
        orderby: ["IF(subject_item='공통',0,1)", 'subject_item', 'number'],
    });
    const throttledRefetch = (0, throttle_1.default)(refetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        throttledRefetch();
    }, [page, test_id]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items } = data;
            (0, functions_1.getSelectSubject)({ test_id, member_id: '' }, true)
                .then(subject_list => {
                setAllSubject(subject_list);
                if (item.type === 'OMR (자유형)') {
                    setOmrType('omr-free');
                    // B13: 자유형도 선택과목(공통 외) 그룹이 있으면 과목 선택 → 해당 과목 문항만 응시
                    if (subject_list.length > 1) {
                        const uniqueSubjectList = subject_list
                            .filter((s) => s !== '공통')
                            .map((s) => ({ id: s, title: s, checked: false }));
                        setSubjectList(uniqueSubjectList);
                    }
                    else {
                        setSubjectList([]);
                    }
                    setTestData(prevTestData => page === 0 ? items : [...prevTestData, ...items]);
                    setTotalCount(total_count);
                }
                else {
                    setOmrType('omr');
                    if (subject_list.length > 1) {
                        const uniqueSubjectList = subject_list
                            .filter(item => item !== '공통')
                            .map(item => ({ id: item, title: item, checked: false }))
                            .sort((a, b) => {
                            const subjectOrder = [
                                '선택 - 미적분',
                                '선택 - 확률과 통계',
                                '선택 - 기하',
                            ];
                            return (
                            // @ts-ignore
                            subjectOrder.indexOf(a.title) -
                                subjectOrder.indexOf(b.title));
                        });
                        // @ts-ignore
                        setSubjectList(uniqueSubjectList);
                    }
                    else {
                        setSubjectList([]);
                    }
                }
            })
                .catch(() => { })
                .finally(() => {
                setTestData(prevTestData => page === 0 ? items : [...prevTestData, ...items]);
                setTotalCount(total_count);
            });
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (selectSubject !== '') {
            const changeData = testData
                ?.map(item => {
                if (item.subject_item === selectSubject)
                    return item;
                else if (item.subject_item === '공통')
                    return item;
                else
                    return null;
            })
                .filter(item => !!item);
            setTestData(changeData);
        }
    }, [selectSubject]);
    const onChange = (questionId, text) => {
        setTestData(prevTestData => prevTestData.map(item => item.id === questionId ? { ...item, myAnswer: text.toString() } : item));
    };
    const handleLoadMore = () => {
        setPage(prevPage => prevPage + 1);
    };
    const onSubmit = async () => {
        // 제출 진행 중이면 무시 — 더블클릭/이중 탭으로 인한 중복 POST 차단
        if (isSubmittingRef.current)
            return;
        isSubmittingRef.current = true;
        try {
            const emptyData = testData.filter(i => !i.myAnswer || i.myAnswer.trim() === '');
            const filterSubject = allSubject.filter(item => !subjectList.find(i => i.title === item));
            if (emptyData && emptyData.length > 0) {
                alert('모든 항목에 답변하지않았습니다.');
                return;
            }
            const limit300 = testData.filter(item => item.myAnswer.length > 300);
            if (limit300 && limit300.length > 0) {
                alert('주관식은 300자 이하로 입력해주세요.');
                return;
            }
            const myAnswerList = testData
                .filter(item => !!item.myAnswer)
                .map(item => ({
                question_id: item.id,
                values: [item.myAnswer],
            }));
            await submitAnswerMutation.mutateAsync({
                id: test_id,
                props: {
                    answers: myAnswerList,
                    subject_items: selectSubject ? [...filterSubject, selectSubject] : [],
                },
            });
            APP.eventManager.publish('ANSWER_REFETCH');
        }
        catch (error) {
            alert(error);
        }
        finally {
            // 성공/실패/검증 중단 모두에서 해제 — 이후의 정상 재제출 허용
            isSubmittingRef.current = false;
        }
    };
    const renderItem = (item, styles) => {
        return tableReadDataKeys.map(headItem => isMobile &&
            (headItem.title === 'subject_item' || headItem.title === 'omr') ? null : (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
                flex: !isMobile && headItem.space,
                ...styles?.bodyItem,
                overflow: 'hidden',
            } }, renderCell(item, headItem))));
    };
    const renderCell = (item, headItem) => {
        // console.log(item);
        switch (headItem.title) {
            case 'omr':
            case 'answer':
            case 'submitAnswer':
                return isMobile ? null : renderAnswerCell(item, headItem);
            case 'point':
            case 'errorRates':
                return isMobile ? (react_1.default.createElement("div", { className: "omr-point-wrap" },
                    renderAnswerCell(item, headItem),
                    renderPointCell(item, headItem))) : (renderPointCell(item, headItem));
            case 'number':
                return isMobile ? (react_1.default.createElement("div", { className: "subject-item-wrap" },
                    react_1.default.createElement("p", { className: "subject-item-title" }, item[headItem.title]),
                    react_1.default.createElement("p", { className: "subject-item-title" }, item['subject_item']))) : (react_1.default.createElement("p", { className: "overText" }, item[headItem.title]));
            default:
                return react_1.default.createElement("p", { className: "overText" }, item[headItem.title]);
        }
    };
    const inputRefs = react_1.default.useRef({});
    const renderAnswerCell = (item, headItem) => {
        if (item.type === 'choice') {
            return (react_1.default.createElement(AnswerContainer_1.AnswerContainer, { isOnlyAnswer: headItem.title === 'answer' || headItem.title === 'submitAnswer', maxCount: item.examples, onChange: text => onChange(item.id, text) }));
        }
        else {
            const isNumber = subject_name === 'math';
            const max = isNumber ? 5 : 300;
            return (react_1.default.createElement(common_1.InputElement, { ref: el => { inputRefs.current[item.id] = el; }, className: "input_answer_wrapper", type: 'text', isNumber: isNumber, maxNumLen: isNumber ? 5 : undefined, isDisable: headItem.title === 'answer' || headItem.title === 'submitAnswer', placeholder: t('assignment.inputAnswerPlaceholder'), onChange: text => {
                    let value = text;
                    if (value.length >= max) {
                        if (!isDesktop) {
                            inputRefs.current[item.id]?.blur();
                        }
                        setTimeout(() => {
                            window.alert(`최대 ${max}자까지 입력 가능합니다.`);
                        }, 100);
                        value = value.slice(0, max);
                    }
                    onChange(item.id, value);
                }, max: max }));
        }
    };
    const renderPointCell = (item, headItem) => {
        return (react_1.default.createElement("div", { className: "input_point_wrapper" },
            react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, defaultValue: item[headItem.title] }),
            headItem.title === 'errorRates' ? '%' : '점'));
    };
    if (subjectList.length > 0 &&
        !selectSubject &&
        ((omrType === 'omr' && item.assignment) || omrType === 'omr-free')) {
        return (react_1.default.createElement(DetailQuestionStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile, "$isTablet": isTablet, className: "field-global-001 detail-question-wrap", style: {
                height: !isOpen ? '100%' : isDesktop ? '260px' : '100%',
                padding: isTablet ? '0 0 20px' : '0 0 16px 0',
            } },
            react_1.default.createElement("div", { className: "fext-field choice-subject-wrap", style: {
                    height: '100%',
                    width: '100%',
                } },
                react_1.default.createElement("div", { className: "label" }, "\uC9C4\uD589\uD560 \uACFC\uBAA9\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                react_1.default.createElement("div", { className: "question-group" },
                    react_1.default.createElement(common_1.CheckBox, { list: subjectList, handlerCheck: id => {
                            setSubjectList(prevList => {
                                return prevList.map(item => {
                                    return {
                                        ...item,
                                        checked: item.id === id,
                                    };
                                });
                            });
                        } }),
                    react_1.default.createElement(common_1.Button, { className: "btn btn_default xmd", text: "\uD655\uC778", onClick: () => {
                            if (!subjectList.find(item => item.checked)) {
                                alert('선택 과목을 선택해주세요.');
                                return;
                            }
                            setSelectSubject(subjectList.find(item => item.checked)?.title || '');
                        } })))));
    }
    return (react_1.default.createElement(DetailQuestionStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile, "$isTablet": isTablet, className: "field-global-001 detail-question-wrap", style: {
            height: !isOpen ? '100%' : isDesktop ? 'auto' : '100%',
            padding: isTablet ? '0 0 20px' : '0',
        } },
        react_1.default.createElement("div", { className: "fext-field", style: { height: !isOpen ? '100%' : 'auto' } },
            react_1.default.createElement(common_1.Table, { className: "task-list-002", showIndex: false, isInfinite: true, page: page, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, styles: {
                    headWrapper: {
                        justifyContent: 'center',
                        alignItems: 'center',
                    },
                    headItem: {
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                }, forceShowheader: isDesktop ? true : false })),
        isTest
            ? null
            : !isMobile && (react_1.default.createElement("div", { className: "button-container" },
                react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "common.submit", onClick: onSubmit }))),
        isMobile && (react_1.default.createElement("div", { className: "submission-header" }, isTest ? null : (react_1.default.createElement(common_1.Button, { className: "btn_grey full", text: "common.submit", onClick: onSubmit }))))));
});
